import { gql } from "@apollo/client"; // saveVisitaParenteral.js


const SAVE_PROGRAMA_CEAE_MEDICO = gql`
  mutation saveVisitaCeaeMedico($input: AddVisitaCeaeMedicoInput!) {
    saveVisitaCeaeMedico(input: $input) {
      idVisita
      idVisitaCeae
    }
  }
`;

export default SAVE_PROGRAMA_CEAE_MEDICO;

export const adaptAddVisitaCEAEMedicoInput = (data) => ({
  idVisitaCeae: data?.idVisitaCeae,
  ingestaOral: !!data?.ingestaOral,
  idComboRIValorAcceso: data?.idComboRIValorTipoAcceso,
  cambioSNG: !!data?.cambioSNG,
  justificaCambio: data?.justificaCambio,
  accesoEnteral: !!data?.accesoEnteral,
  justificaAccesoEnteral: data?.justificaAccesoEnteral,
  negativaGastrostomia: !!data?.negativaGastrostomia,
  justificaGastrostomia: data?.justificaGastrostomia,
  justificacionModificacion: data?.justificacionModificacion,
  idComboRIValorModoInfusion: data?.idComboRIValorModoInfusion,
  llevaBomba: !!data?.llevaBomba,
  formaPreparacion: data?.formaPreparacion,
  indicacionEspecial: data?.indicacionEspecial,
  flujo: data?.flujo,
  hidratacion: !!data?.hidratacion,
  indicacionHidratacion: data?.indicacionHidratacion,
  suplementoVitaminico: !!data?.suplementoVitaminico,
  suplemento: data?.suplemento,
  indicacionSuplemento: data?.indicacionSuplemento,
  proteinasTotales: data?.proteinasTotales,
  caloriasTotales: data?.caloriasTotales,
  cantidadAnticonvulsivante: data?.cantidadAnticonvulsivante,
  medicacionAnticonvulsivante: data?.medicacionAnticonvulsivante,
  cetonemia: !!data?.cetonemia,
  resultadoCetonemia: data?.resultadoCetonemia,
  cetonuria: !!data?.cetonuria,
  resultadoCetonuria: data?.resultadoCetonuria,
  cantidadCrisis: data?.cantidadCrisis,
  observacion: data?.observacion,
  complicaciones: data?.complicaciones,
  listaIndicacion: data?.listaIndicacion?.map((item) => ({
    idInsumo: item?.idInsumo,
    cantidadDiaria: item?.cantidadDiaria
  })),
  idVisita: data?.idVisita
});